import { render } from "./page-other-services.vue?vue&type=template&id=8e9ebc9a&scoped=true"
import script from "./page-other-services.vue?vue&type=script&lang=js"
export * from "./page-other-services.vue?vue&type=script&lang=js"

import "./page-other-services.vue?vue&type=style&index=0&id=8e9ebc9a&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e9ebc9a"]])

export default __exports__